import { render } from "./MfgShipmentScheduleArea.vue?vue&type=template&id=77f70c36&scoped=true"
import script from "./MfgShipmentScheduleArea.vue?vue&type=script&lang=js"
export * from "./MfgShipmentScheduleArea.vue?vue&type=script&lang=js"

import "./MfgShipmentScheduleArea.vue?vue&type=style&index=0&id=77f70c36&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f70c36"]])

export default __exports__